export { default } from "./JumbotronResolver";
export * from "./JumbotronResolver";
export * from "./Jumbotron.model";
